



/*Header menu-drawer-open start */
document.addEventListener('DOMContentLoaded', function() {
  var detailsElements = document.querySelectorAll('header-menu details');
  detailsElements.forEach(function(details) {
    details.addEventListener('mouseenter', function() {
      this.setAttribute('open', 'open');
    });
    details.addEventListener('mouseleave', function() {
      this.removeAttribute('open');
    });
  });
});

// inupt header icon filled 
document.addEventListener('DOMContentLoaded', function () {
});
document.querySelectorAll('.buy_nowz_btn').forEach(function(button) {
  button.addEventListener('click', function() {
        document.querySelectorAll('.buy_variants').forEach(function(variant) {
      variant.classList.remove('show_variants');
    });
    var index = Array.from(document.querySelectorAll('.buy_nowz_btn')).indexOf(this);
    document.querySelectorAll('.buy_variants')[index].classList.add('show_variants');
  });
});

document.querySelectorAll('.buy_variants_head .close_icon').forEach(function(icon) {
  icon.addEventListener('click', function() {
    var index = Array.from(document.querySelectorAll('.buy_variants_head .close_icon')).indexOf(this);
    document.querySelectorAll('.buy_variants')[index].classList.remove('show_variants');
  });
});

// buy now -quantity selector
 document.addEventListener('DOMContentLoaded', function() {
    document.body.addEventListener('click', function(event) {
      var cart = document.querySelector("cart-drawer");
      var clickedElement = event.target;
      if (clickedElement.classList.contains('custom_ATC_plus')) {
        var variantId = clickedElement.parentElement.querySelector('.quantity__input').getAttribute('data-quantity-variant-id');
        var quantity = parseInt(clickedElement.parentElement.querySelector('.quantity__input').value);

        let data = [];
        data.push({
          'id': variantId,
          'quantity': 1
        });
        let formData = {
          'items': data,
          sections: cart.getSectionsToRender().map((section) => section.id),
        };
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(formData)
        }).then((response) => {
          return response.json();
        }).then((resp) => {
          cart.renderContents(resp,true);
          console.log("Response from server:", resp);
          cart.classList.remove("is-empty");
        }).catch(error => {
          console.log("ERROR :", error);
        }).finally(() => {
          var viewCart = document.querySelector('.custom_fixed_cart');
           viewCart.classList.remove('cartQty');
        });
      }
      else if (clickedElement.classList.contains('custom_ATC_minus')) {
        var variantId = clickedElement.parentElement.querySelector('.quantity__input').getAttribute('data-quantity-variant-id');
        var quantity = parseInt(clickedElement.parentElement.querySelector('.quantity__input').value);
        let data = {};
        data[variantId] = quantity--;
        let formData = {
          'updates': data,
          sections: cart.getSectionsToRender().map((section) => section.id),
        };
        fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(formData)
        }).then((response) => {
          return response.json();
        }).then((resp) => {
          cart.renderContents(resp,true);
          cart.classList.remove("is-empty");
        }).catch(error => {
          console.log("ERROR :", error);
        }).finally(() => {
          var viewCart = document.querySelector('.custom_fixed_cart');
           viewCart.classList.remove('cartQty');
        });
      }
      
    });
    var cartBtn = document.querySelectorAll('.template-index .buy_variants_cart');
    var cartBtn2 = document.querySelectorAll('.custom_ATC_button');
    var cartRemove = document.querySelectorAll('.cart-remove-button');
    cartBtn.forEach(function(btn) {
    btn.addEventListener('click', function() {
    btn.classList.add('cartQty');
    var index = Array.from(cartBtn).indexOf(btn);
    if (index !== -1 && index < cartBtn2.length) {
      cartBtn2[index].classList.remove('cartQty2');
    }
  });
}); 
   var cartBtnz = document.querySelectorAll('.quick-add__submit');
   var cartBtnz2 = document.querySelectorAll('.custom_ATC_button');
      cartBtnz.forEach(function(element) {
      element.addEventListener('click', function() {
            this.classList.add('cartQty');
        var variantId = element.getAttribute('data-first-variant');
        var cartBenchVariant = document.querySelector('[data-variant="' + variantId + '"]');
        if (cartBenchVariant) {
          cartBenchVariant.classList.remove('cartQty2');  
        }
      });
    });
 });  
// product description
document.addEventListener('DOMContentLoaded', function() {
    var descriptionHeading = document.querySelector('.description-heading1');
    var productDescription = document.querySelector('.cstm-product-description');
    
    descriptionHeading.addEventListener('click', function() {
        productDescription.classList.toggle('active');
    });
});

// header search bar
var search_slisers = document.querySelectorAll('.search_cstm');
var contents = document.querySelectorAll('.header-dropdown');
var cross_svgs = document.querySelectorAll('.cross-svg');
var isContentVisible = false;
function setContentVisibility(visible) {
    contents.forEach(function(content) {
        content.style.visibility = visible ? 'visible' : 'hidden';
    });
    isContentVisible = visible;
}

// Add click event listener to all .search_cstm elements
search_slisers.forEach(function(search_sliser) {
    search_sliser.addEventListener('click', function (event) {
        event.stopPropagation();
        setContentVisibility(!isContentVisible);
    });

    search_sliser.addEventListener('keyup', function(event) {
        setContentVisibility(false);
    });
});

// Add click event listener to all .cross-svg elements
cross_svgs.forEach(function(cross_svg) {
    cross_svg.addEventListener('click', function(event) {
        event.stopPropagation();
        setContentVisibility(false);
    });
});

// Stop propagation on each .header-dropdown element
contents.forEach(function(content) {
    content.addEventListener('click', function(event) {
        event.stopPropagation();
    });
});
$(document).ready(function() {
    function initializeSlick() {
        $('.searchslider').slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            autoplay: false,
            autoplaySpeed: 2000,
            prevArrow: '<button class="left-button"><svg width="35" height="35" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_92_100)"><path d="M22.4729 24.1938L15.7937 17.5L22.4729 10.8062L20.4167 8.75L11.6667 17.5L20.4167 26.25L22.4729 24.1938Z" fill="#1f867c"/></g><defs><clipPath id="clip0_92_100"><rect width="35" height="35" fill="white" transform="matrix(-1 0 0 1 35 0)"/></clipPath></defs></svg></button>',
            nextArrow: '<button class="right-button"><svg xmlns="http://www.w3.org/2000/svg" height="35" viewBox="0 0 24 24" width="35" fill="#1f867c"> <path d="M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"></path><path d="M0 0h24v24H0V0z" fill="none"></path></svg></button>',
            responsive: [
                {
                    breakpoint: 768, // tablet and below
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 480, // mobile and below
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        arrows:false
                    }
                }
            ]
        });
    }
    initializeSlick();
});

const search = () => {
    const searchbox = document.getElementById("Search-In-Modal").value.toUpperCase();
    const storeitems = document.getElementById("product-grid");
    const products = storeitems.getElementsByClassName("grid__item");
    const pname = storeitems.getElementsByTagName("h3");

    for (var i = 0; i < pname.length; i++) {
        let match = products[i].getElementsByTagName('h3')[0];
       console.log(match);

        if (match) {
            let textvalue = match.textContent || match.innerHTML;

            if (textvalue.toUpperCase().indexOf(searchbox) > -1) {
                products[i].style.display = "";
            } else {
                products[i].style.display = "none";
            }
        }
    }
}
const names = ['Refills & Pods ', 'Vape Kits ', 'E-Liquids '];
const paras = document.querySelectorAll('.typewriter');
let currentNameIndex = 0;
let forwardTyping = true;

function typewriterEffect(para) {
    const currentName = names[currentNameIndex];
    let i = 0;
    let intervalId;

    intervalId = setInterval(function() {
        if (forwardTyping && i < currentName.length) {
            let nextChar = currentName.charAt(i) === ' ' ? '&nbsp;' : currentName.charAt(i);
            para.innerHTML += nextChar;
            i++;
        } else if (!forwardTyping && i >= 0) {
            para.innerHTML = currentName.substring(0, i).replace(/ /g, '&nbsp;');
            i--;
        } else {
            clearInterval(intervalId);
            setTimeout(function() {
                forwardTyping = !forwardTyping;
                if (!forwardTyping) {
                    currentNameIndex = (currentNameIndex + 1) % names.length;
                }
                para.innerHTML = '';
                typewriterEffect(para);
            }, 1000);
        }
    }, 200);
}
// Apply the typewriter effect to each element with the class "typewriter"
paras.forEach(para => {
    typewriterEffect(para);
});

// on hover menu bar
document.addEventListener('DOMContentLoaded', function() {
  let items = document.querySelectorAll(".header__inline-menu .header__menu-item");
  var menus = document.querySelectorAll(".mega-menu__content");
  items.forEach(item => {
    item.addEventListener("mouseover", () => {
      item.closest('details').setAttribute("open", true);
    });
    item.addEventListener("mouseout", () => {
      setTimeout(() => {
        if (!item.closest('details').matches(":hover")) {
          item.closest('details').removeAttribute("open");
        }
      }, 0);
    });
  });
});



$(document).ready(function () {
        const $checkbox = $('.trems-condition input[type="checkbox"]');
        const $checkoutButton = $('#CartDrawer-Checkout');

        // Initially disable the checkout button and set its opacity
        $checkoutButton.prop('disabled', true).css('opacity', 0.6);

        // Function to toggle the button's disabled state and opacity based on the checkbox
        function toggleCheckoutButton() {
            const isChecked = $checkbox.is(':checked');
            $checkoutButton.prop('disabled', !isChecked);
            $checkoutButton.css('opacity', isChecked ? 1 : 0.6);
        }

        // Attach change event listener to the checkbox
        $checkbox.change(toggleCheckoutButton);
    });







 function updateTime() {
  const now = new Date();
  const day = now.getDay(); // 0 for Sunday, 6 for Saturday

  // Check if it's after 6 PM or Saturday/Sunday
  const isWeekend = (day === 0 || day === 6);
  const isAfter6PM = now.getHours() >= 18;

  // Get all elements with the class 'fd-hider'
  const fdHiderElements = document.getElementsByClassName('product-fd-hider');

  if (isAfter6PM || isWeekend) {
    // Clear the text for fd-hider elements
    for (const element of fdHiderElements) {
      element.innerText = '';
    }
    
    // Display message for free delivery on weekends and after 6 PM
    const message = "Free Delivery on Orders Over £20";
    document.getElementById('countdownTimer2').innerText = message;
    document.getElementById('countdownTimer-latest').innerText = message;
  } else {
    // Set text for fd-hider elements
    for (const element of fdHiderElements) {
      element.innerText = 'Want it tomorrow? Order in the next';
    }

    // Calculate the target time (next 6 PM)
    let target = new Date(now);
    target.setHours(18, 0, 0, 0); // Set target time to 6 PM
    if (now.getHours() >= 18) {
      // If it's past 6 PM, set target to 6 PM next day
      target.setDate(target.getDate() + 1);
    }

    // Calculate the difference in milliseconds
    const diff = target - now;

    // Convert milliseconds to hours, minutes, and seconds
    const hoursLeft = Math.floor(diff / (1000 * 60 * 60));
    const minutesLeft = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    const secondsLeft = Math.floor((diff % (1000 * 60)) / 1000);

    // Ensure double digits for single numbers
    const displayHours = String(hoursLeft).padStart(2, '0');
    const displayMinutes = String(minutesLeft).padStart(2, '0');
    const displaySeconds = String(secondsLeft).padStart(2, '0');

    // Display the time left in HH:MM:SS format
    const timeString = `${displayHours}H ${displayMinutes}M ${displaySeconds}S`;
    document.getElementById('countdownTimer2').innerText = timeString;
    document.getElementById('countdownTimer-latest').innerText = timeString;
  }
}

// Update the timer every second
setInterval(updateTime, 1000);

// Initial call to display the timer immediately on load
updateTime();


















